import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWorkOrders = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		stroke: "#748094",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.2,
		clipPath: "url(#a)",
		children: [/* @__PURE__ */ _jsx("path", { d: "M2.5 16.25V5a.625.625 0 0 1 .625-.625h4.164c.135 0 .267.044.375.125l2.172 1.625c.108.08.24.124.375.125h5.414a.625.625 0 0 1 .625.625V8.75" }), /* @__PURE__ */ _jsx("path", { d: "m2.5 16.25 2.36-7.07a.625.625 0 0 1 .593-.43h12.43a.625.625 0 0 1 .594.82l-2.227 6.68z" })]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "a",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M0 0h20v20H0z"
		})
	}) })]
});
export default SvgWorkOrders;
